module.exports = __webpack_public_path__ + "static/media/clients-video.e39542c1.png";